<template>
  <div class="card-body">
    <div v-if="partnerInternal.socialId">
      <h4 class="py-3"><b>{{ partnerInternal.firstName }} {{ partnerInternal.fatherName }} {{
        partnerInternal.grandFatherName }}
          {{ partnerInternal.familyName }}</b></h4>
      <div class="form-row justify-content-start" v-if="partner">
        <div class="form-group col-lg-2 col-md-2 col-sm-12">
          <label for="disabledTextInput">الجنسية</label>
          <p> <b>{{ partnerInternal.nationalityDescAr }}</b></p>
        </div>
        <div class="form-group col-lg-2 col-md-2 col-sm-12" v-if="partnerInternal.socialId">
          <label for="disabledTextInput">نوع الهوية</label>
          <p> <b> {{ partnerInternal.socialId | getSocialIdType }}</b></p>
        </div>
        <div class="form-group col-lg-2 col-md-2 col-sm-12">
          <label for="disabledTextInput">رقم الهوية</label>
          <p> <b> {{ partnerInternal.socialId }} </b></p>
        </div>
        <div class="form-group col-lg-2 col-md-2 col-sm-12">
          <label for="disabledTextInput">النوع</label>
          <p> <b> {{ partnerInternal.genderDesc }} </b></p>
        </div>
        <div class="form-group col-lg-4 col-md-4 col-sm-12" v-if="partnerInternal.birthDate">
          <label for="disabledTextInput">تاريخ الميلاد</label>
          <p> <b> {{ partnerInternal.birthDateHijri }} هـ - {{ partnerInternal.birthDate | getFormattedDate }}م </b></p>
        </div>
      </div>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent>
          <div class="form-row">
            <div class="col-md-4">
              <label for="inputEmail4" class="pb-2">رقم الجوال</label>
              <MobileComponent v-model="partnerInternal.mobileNumber"
                hint="سيتم إرسال الاشعارات على رقم الجوال المسجل في أبشر" persistent-hint></MobileComponent>
            </div>
          </div>
          <div class="form-row" v-if="isLawyer">
            <div class="col-md-4">
              <label for="inputEmail4" class="pb-2">الصفة</label>
              <div class="form-row mx-0 text-center">
                <a @click="changeSefa(false)" @keypress="() => { }" role="button" tabindex="0"
                  class=" align-items-center col ml-1" :class="(!isLawyerTabActive) ? 'tab-active' : 'tab-inactive'">أصالة
                  عن نفسه</a>
                <a v-if="isLawyer" @click="changeSefa(true)" @keypress="() => { }" role="button" tabindex="0"
                  class=" align-items-center col mr-1"
                  :class="(isLawyerTabActive) ? 'tab-active' : 'tab-inactive'">محامي</a>
              </div>
            </div>
          </div>
          <div v-if="!isLawyerTabActive" class="mb-3">
            <div class="alert alert-primary alert-info" role="alert" v-if="!isSetSecondPartSefa">
              <i class="fal fa-info-circle"></i><span class="mr-2">يتم تعيين بيانات هذا الطرف باعتباره الطرف الأول في
                العقد بشكل افتراضي</span>
            </div>
            <div class="custom-control custom-checkbox ">
              <input type="checkbox" class="custom-control-input" id="customCheck2" v-model="isSetSecondPartSefa"
                @change="changeSecondPartner">
              <label class="custom-control-label" for="customCheck2">
                تعيين مقدم الطلب كطرف ثانٍ
              </label>
            </div>
          </div>
          <div v-if="isLawyerTabActive && isLawyer" class="form-row">
            <div class="col-md">
              <NumberComponent v-bind:inputValue.sync="partnerInternal.licenseNumber" label="رقم رخصة المحاماة"
                placeholder="رخصة المحامي" name="lawyerLicenseNo"></NumberComponent>
            </div>
          </div>
          <div class="mt-8">
            <button type="submit" class="btn button--greenFill px-8" @click="handleSubmit(addPartner)">
              <span>إضافة</span>
            </button>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <div style="display:none">
      <ConfirmComponent ref="confirm"></ConfirmComponent>
    </div>
  </div>
</template>

<script lang="ts">
import {
  Component, Vue, Watch, Prop,
} from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import MobileComponent from '@/components/mobile.component.vue';
import NumberComponent from '@/components/number.component.vue';
import ConfirmComponent from '@/components/Shared/confirm.component.vue';
import ExternalService from '@/services/external';
import UserService from '@/services/user';
import { ContractPartnerModel } from '@/models/contractPartnerModel';
import { moduleProxy } from '../../store';
import { PartnerApprovalEnum } from '@/enums/partnerApprovalEnum';
import { PartnerApprovalHistoryModel } from '@/models/partnerApprovalHistoryModel';
import { DateTimeHelper } from '@/utils/date-time.helper';

@Component({
  components: {
    MobileComponent,
    NumberComponent,
    ConfirmComponent,
  },
  diProvide: [
    ExternalService,
    UserService,
  ],
})

export default class ApplicantComponent extends Vue {
  @Inject(ExternalService) public externalService!: ExternalService;
  @Inject(UserService) public userService!: UserService;
  @Prop({ default: { licenseNumber: 2123321231 } as ContractPartnerModel }) partner!: ContractPartnerModel;
  @Prop() tarafType!: number;
  isLawyerTabActive = false;
  partnerInternal: ContractPartnerModel = {} as ContractPartnerModel;
  isSetSecondPartSefa = false;

  mounted() {
    if (this.partner && this.partner != null && this.partner.socialId) {
      this.partnerInternal = this.partner;
    }

    this.partnerInternal.approvalStatusId = PartnerApprovalEnum.Approved;
    this.partnerInternal.najizApprovalHistory = [{ statusId: PartnerApprovalEnum.Approved }] as PartnerApprovalHistoryModel[];
    this.isLawyerTabActive = this.partner.isLawyerTabActive;
    this.isSetSecondPartSefa = this.partner.isSetSecondPartSefa;

    if (this.isLawyerTabActive && !this.isLawyer) {
      this.isLawyerTabActive = false;
    }
  }

  @Watch('partner')
  async watchIsSecondPartSefa() {
    this.partnerInternal = this.partner;
    this.partnerInternal.approvalStatusId = PartnerApprovalEnum.Approved;
    this.partnerInternal.najizApprovalHistory = [{ statusId: PartnerApprovalEnum.Approved }] as PartnerApprovalHistoryModel[];
  }

  addPartner() {
    if (this.partnerInternal && this.partnerInternal.licenseNumber && this.isLawyerTabActive) {
      this.externalService.checkLicenseExpiry(this.partnerInternal.socialId, this.partnerInternal.licenseNumber).then((response) => {
        const licenseInfo = response.model;
        this.partnerInternal.licenseNumber = licenseInfo.licenseNumber;
        this.partnerInternal.licenseStatus = licenseInfo.status;
        this.partnerInternal.licenceDate = licenseInfo.licenceDate;
        this.partnerInternal.licenceDateHijri = DateTimeHelper.convertToHijri(licenseInfo.licenceDateHijri);
        this.partnerInternal.licenceEndDate = licenseInfo.licenceEndDate;
        this.partnerInternal.licenceEndDateHijri = DateTimeHelper.convertToHijri(licenseInfo.licenceEndDateHijri);
        this.$emit('addActivePartner', this.partnerInternal);
      });
    } else {
      this.$emit('addActivePartner', this.partnerInternal);
    }
  }

  checkLicenseExpiry() {
    if (this.partnerInternal && this.partnerInternal.licenseNumber) {
      this.externalService.checkLicenseExpiry(this.partnerInternal.socialId, this.partnerInternal.licenseNumber);
    }
  }

  async changeSefa(value: boolean) {
    const partnersToRemove = moduleProxy.Contract.getContractPartners.filter((x) => x !== this.partner);

    if (partnersToRemove && partnersToRemove.length > 0) {
      if (
        await (this.$refs as any).confirm.open(
          'رسالة تنبيه',
          ' سوف يتم يتم حذف الأطراف المضافة عند تغيير الصفة!',
          '',
        )
      ) {
        // remove all partner items except current
        this.isLawyerTabActive = value;
        moduleProxy.Contract.removeContractPartners(partnersToRemove);
        this.partnerInternal.isLawyerTabActive = this.isLawyerTabActive;
        if (this.isLawyerTabActive) {
          this.partnerInternal.partnerSefaTypeId = 2; // محامي
          this.partnerInternal.partnerTarafTypeId = 3; // محامي
        } else {
          this.partnerInternal.partnerSefaTypeId = 1; // طرف أول
          this.partnerInternal.partnerTarafTypeId = 1; // طرف أول
        }
      }
    } else {
      this.isLawyerTabActive = value;
      this.partnerInternal.isLawyerTabActive = this.isLawyerTabActive;
      if (this.isLawyerTabActive) {
        this.partnerInternal.partnerSefaTypeId = 2; // محامي
        this.partnerInternal.partnerTarafTypeId = 3; // محامي
      } else {
        this.partnerInternal.partnerSefaTypeId = 1; // طرف أول
        this.partnerInternal.partnerTarafTypeId = 1; // طرف أول
      }
    }
  }

  async changeSecondPartner(value: any) {
    const partnersToRemove = moduleProxy.Contract.getContractPartners.filter((x) => x !== this.partner);

    if (partnersToRemove && partnersToRemove.length > 0) {
      if (
        await (this.$refs as any).confirm.open(
          'رسالة تأكيد',
          'سوف يتم يتم حذف الأطراف المضافة عند تغيير الصفة!',
          '',
        )
      ) {
        // remove all partner items except current
        this.isSetSecondPartSefa = value.srcElement.checked;
        moduleProxy.Contract.removeContractPartners(partnersToRemove);
        this.partnerInternal.isSetSecondPartSefa = this.isSetSecondPartSefa;
        if (this.isSetSecondPartSefa) {
          this.partnerInternal.partnerTarafTypeId = 2;
        } else {
          this.partnerInternal.partnerTarafTypeId = 1;
        }
      } else {
        this.isSetSecondPartSefa = !this.isSetSecondPartSefa;
      }
    } else {
      this.isSetSecondPartSefa = value.srcElement.checked;
      this.partnerInternal.isSetSecondPartSefa = this.isSetSecondPartSefa;
      if (this.isSetSecondPartSefa) {
        this.partnerInternal.partnerTarafTypeId = 2;
      } else {
        this.partnerInternal.partnerTarafTypeId = 1;
      }
    }
  }

  get contractPartners() {
    return moduleProxy.Contract.getContractPartners;
  }

  get isLawyer() {
    const contract = moduleProxy.Contract.getContract;
    return contract.hasLawyer;
  }
}
</script>
